<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
  >
    <div
      class="trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between"
    >
      <div class="trezo-card-title">
        <form class="relative sm:w-[265px]">
          <label
            class="leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2"
          >
            <i class="material-symbols-outlined !text-[20px]"> search </i>
          </label>
          <input
            v-model="searchQuery"
            type="text"
            :placeholder="directT('contacts.searchContacts')"
            class="bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400"
          />
        </form>
      </div>
      <div class="trezo-card-subtitle mt-[15px] sm:mt-0">
        <div class="trezo-card-dropdown relative">
          <button
            type="button"
            class="trezo-card-dropdown-btn inline-block rounded-md border border-gray-100 py-[5px] md:py-[6.5px] px-[12px] md:px-[19px] transition-all hover:bg-gray-50 dark:border-[#172036] dark:hover:bg-[#0a0e19]"
            id="dropdownToggleBtn"
            @click="toggleDropdown"
          >
            <span
              class="inline-block relative ltr:pr-[17px] ltr:md:pr-[20px] rtl:pl-[17px] rtl:ml:pr-[20px]"
            >
              {{ getDisplayStatusFilter() }}
              <i
                class="ri-arrow-down-s-line text-lg absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2"
              ></i>
            </span>
          </button>
          <ul
            v-if="showDropdown"
            class="trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none"
          >
            <li>
              <button
                type="button"
                class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
                @click="setStatusFilter('All')"
              >
                {{ directT('contacts.all') }}
              </button>
            </li>
            <li>
              <button
                type="button"
                class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
                @click="setStatusFilter('active')"
              >
                {{ directT('contacts.active') }}
              </button>
            </li>
            <li>
              <button
                type="button"
                class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
                @click="setStatusFilter('deactive')"
              >
                {{ directT('contacts.inactive') }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="trezo-card-content -mx-[20px] md:-mx-[25px]">
      <div class="table-responsive overflow-x-auto">
        <table class="w-full">
          <thead class="text-black dark:text-white">
            <tr>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                <div class="form-check relative top-[2px]">
                  <input type="checkbox" class="cursor-pointer" v-model="selectAll" @change="toggleSelectAll" />
                </div>
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('contacts.id') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('contacts.name') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('contacts.phone') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('contacts.lastContacted') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('contacts.status') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('contacts.actions') }}
              </th>
            </tr>
          </thead>
          <tbody class="text-black dark:text-white">
            <tr v-if="loading">
              <td colspan="7" class="text-center py-4">{{ directT('contacts.loading') }}</td>
            </tr>
            <tr v-else-if="filteredContacts.length === 0">
              <td colspan="7" class="text-center py-4">{{ directT('contacts.noContactsFound') || 'No contacts found' }}</td>
            </tr>
            <tr v-for="contact in filteredContacts" :key="contact.id">
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <div class="form-check relative top-[2px]">
                  <input type="checkbox" class="cursor-pointer" v-model="selectedContacts" :value="contact.id" />
                </div>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <span class="text-gray-500 dark:text-gray-400">
                  #{{ contact.id.substring(0, 4) }}
                </span>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <div class="flex items-center">
                  <div class="rounded-md w-[40px] rounded-full">
                    <img
                      :src="contact.profile_picture_link || getRandomUserImage()"
                      class="inline-block rounded-full"
                      alt="contact-image"
                    />
                  </div>
                  <div class="ltr:ml-[12px] rtl:mr-[12px]">
                    <span class="block font-medium">{{ contact.name }}</span>
                  </div>
                </div>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <span class="text-gray-500 dark:text-gray-400">
                  {{ contact.phone || directT('contacts.notAvailable') }}
                </span>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <span class="text-gray-500 dark:text-gray-400">
                  {{ formatDate(contact.last_contact) }}
                </span>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <span
                  :class="{
                    'px-[8px] py-[3px] inline-block rounded-sm font-medium text-xs': true,
                    'bg-primary-50 dark:bg-[#15203c] text-primary-500': contact.status === 'active',
                    'bg-orange-100 dark:bg-[#15203c] text-orange-600': contact.status === 'deactive'
                  }"
                >
                  {{ getStatusDisplay(contact.status) }}
                </span>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <div class="flex items-center gap-[9px]">
                  <button
                    type="button"
                    class="text-primary-500 leading-none custom-tooltip"
                    v-tooltip="directT('contacts.viewContact')"
                    @click="viewContact(contact)"
                  >
                    <i class="material-symbols-outlined !text-md">
                      visibility
                    </i>
                  </button>
                  <button
                    type="button"
                    class="text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
                    v-tooltip="directT('contacts.editContact')"
                    @click="editContact(contact)"
                  >
                    <i class="material-symbols-outlined !text-md"> edit </i>
                  </button>
                  <button
                    type="button"
                    class="text-danger-500 leading-none custom-tooltip"
                    v-tooltip="directT('contacts.deleteContact')"
                    @click="deleteContact(contact.id)"
                  >
                    <i class="material-symbols-outlined !text-md"> delete </i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <Pagination 
        :current-page="currentPage" 
        :total-items="totalContacts" 
        :items-per-page="itemsPerPage"
        @page-changed="handlePageChange"
        class="px-[20px] md:px-[25px]" 
      />
    </div>

    <!-- Edit Contact Popup -->
    <div v-if="showEditPopup" class="fixed inset-0 z-50 overflow-y-auto">
      <div class="flex items-center justify-center min-h-screen p-4">
        <div class="fixed inset-0 bg-black opacity-50"></div>
        <div class="relative bg-white dark:bg-[#0c1427] rounded-lg shadow-xl max-w-md w-full p-6 z-50">
          <div class="flex justify-between items-center mb-4">
            <h3 class="text-lg font-medium text-gray-900 dark:text-white">{{ directT('contacts.editContactTitle') }}</h3>
            <button @click="closeEditPopup" class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
              <i class="material-symbols-outlined !text-xl">close</i>
            </button>
          </div>
          
          <div class="space-y-4">
            <!-- Name -->
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">{{ directT('contacts.name') }}</label>
              <input 
                type="text" 
                v-model="editForm.name" 
                class="bg-gray-50 border border-gray-100 p-2 rounded-md w-full text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
              />
            </div>
            
            <!-- Phone -->
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">{{ directT('contacts.phone') }}</label>
              <input 
                type="text" 
                v-model="editForm.phone" 
                class="bg-gray-50 border border-gray-100 p-2 rounded-md w-full text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
              />
            </div>
            
            <!-- Status -->
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">{{ directT('contacts.status') }}</label>
              <select 
                v-model="editForm.status" 
                class="bg-gray-50 border border-gray-100 p-2 rounded-md w-full text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
              >
                <option value="active">{{ directT('contacts.active') }}</option>
                <option value="deactive">{{ directT('contacts.inactive') }}</option>
              </select>
            </div>
            
            <!-- Profile Picture URL -->
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Profile Picture URL</label>
              <input 
                type="text" 
                v-model="editForm.profile_picture_link" 
                class="bg-gray-50 border border-gray-100 p-2 rounded-md w-full text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
                placeholder="Leave empty to use default image"
              />
            </div>
            
            <div class="flex justify-end space-x-3 mt-4">
              <button 
                @click="closeEditPopup" 
                class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-[#172036] hover:bg-gray-50 dark:hover:bg-[#0a0e19]"
              >
                {{ directT('contacts.cancel') }}
              </button>
              <button 
                @click="saveContactChanges" 
                class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-500 hover:bg-primary-600"
              >
                {{ directT('contacts.save') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- View Contact Popup -->
    <div v-if="showViewPopup" class="fixed inset-0 z-50 overflow-y-auto">
      <div class="flex items-center justify-center min-h-screen p-4">
        <div class="fixed inset-0 bg-black opacity-50"></div>
        <div class="relative bg-white dark:bg-[#0c1427] rounded-lg shadow-xl max-w-md w-full p-6 z-50">
          <div class="flex justify-between items-center mb-4">
            <h3 class="text-lg font-medium text-gray-900 dark:text-white">{{ directT('contacts.contactDetails') }}</h3>
            <button @click="closeViewPopup" class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
              <i class="material-symbols-outlined !text-xl">close</i>
            </button>
          </div>
          
          <div class="space-y-6">
            <!-- Contact Image -->
            <div class="flex justify-center">
              <div class="rounded-full w-24 h-24 overflow-hidden">
                <img 
                  :src="currentViewContact?.profile_picture_link || getRandomUserImage()" 
                  class="w-full h-full object-cover"
                  alt="Contact profile"
                />
              </div>
            </div>
            
            <!-- Contact Details -->
            <div class="space-y-4">
              <!-- ID -->
              <div>
                <label class="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{{ directT('contacts.id') }}</label>
                <div class="text-gray-900 dark:text-white font-medium">
                  {{ currentViewContact?.id }}
                </div>
              </div>
              
              <!-- Name -->
              <div>
                <label class="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{{ directT('contacts.name') }}</label>
                <div class="text-gray-900 dark:text-white font-medium">
                  {{ currentViewContact?.name }}
                </div>
              </div>
              
              <!-- Phone -->
              <div>
                <label class="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{{ directT('contacts.phone') }}</label>
                <div class="text-gray-900 dark:text-white font-medium">
                  {{ currentViewContact?.phone || directT('contacts.notAvailable') }}
                </div>
              </div>
              
              <!-- Last Contact -->
              <div>
                <label class="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{{ directT('contacts.lastContacted') }}</label>
                <div class="text-gray-900 dark:text-white font-medium">
                  {{ formatDate(currentViewContact?.last_contact) }}
                </div>
              </div>
              
              <!-- Status -->
              <div>
                <label class="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{{ directT('contacts.status') }}</label>
                <div>
                  <span
                    :class="{
                      'px-[8px] py-[3px] inline-block rounded-sm font-medium text-xs': true,
                      'bg-primary-50 dark:bg-[#15203c] text-primary-500': currentViewContact?.status === 'active',
                      'bg-orange-100 dark:bg-[#15203c] text-orange-600': currentViewContact?.status === 'deactive'
                    }"
                  >
                    {{ currentViewContact ? getStatusDisplay(currentViewContact.status) : '' }}
                  </span>
                </div>
              </div>
              
              <!-- Created At -->
              <div>
                <label class="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Created At</label>
                <div class="text-gray-900 dark:text-white font-medium">
                  {{ formatDate(currentViewContact?.created_at) }}
                </div>
              </div>
              
              <!-- Updated At -->
              <div>
                <label class="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Updated At</label>
                <div class="text-gray-900 dark:text-white font-medium">
                  {{ formatDate(currentViewContact?.updated_at) }}
                </div>
              </div>
            </div>
            
            <div class="flex justify-end space-x-3 mt-4">
              <button 
                @click="closeViewPopup" 
                class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-[#172036] hover:bg-gray-50 dark:hover:bg-[#0a0e19]"
              >
                {{ directT('contacts.close') }}
              </button>
              <button 
                @click="editContact(currentViewContact)"
                class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-500 hover:bg-primary-600"
              >
                {{ directT('contacts.editContact') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, watch, reactive } from "vue";
import Pagination from "@/components/Common/Pagination.vue";
import { supabase } from "@/lib/supabaseClient";
import { profileService } from "@/utils/supabase";
import { useI18n } from "vue-i18n";
import enTranslations from "@/i18n/locales/en.json";
import heTranslations from "@/i18n/locales/he.json";
import arTranslations from "@/i18n/locales/ar.json";

// Type definition for translation objects
type TranslationObject = {
  [key: string]: string | TranslationObject;
};

export default defineComponent({
  name: "ContactsList",
  components: {
    Pagination,
  },
  setup() {
    // i18n setup
    const { locale } = useI18n();

    // Translation files
    const translationFiles = {
      en: enTranslations,
      he: heTranslations,
      ar: arTranslations
    };

    // Direct translation function that bypasses vue-i18n
    const directT = (key: string): string => {
      const parts = key.split('.');
      let result: TranslationObject = translationFiles[locale.value as keyof typeof translationFiles];
      
      for (const part of parts) {
        if (!result || !(part in result)) {
          console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
          // Fallback to English if translation not found
          let enResult: TranslationObject = translationFiles.en;
          for (const fallbackPart of parts) {
            if (!enResult || !(fallbackPart in enResult)) return key;
            enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
          }
          return typeof enResult === 'string' ? enResult : key;
        }
        result = result[part as keyof typeof result] as TranslationObject;
      }
      return typeof result === 'string' ? result : key;
    };

    const contacts = ref<any[]>([]);
    const loading = ref(true);
    const searchQuery = ref("");
    const statusFilter = ref("All");
    const showDropdown = ref(false);
    const selectedContacts = ref<string[]>([]);
    const selectAll = ref(false);
    const currentPage = ref(1);
    const itemsPerPage = ref(10);
    const totalContacts = ref(0);
    const organizationId = ref<number | null>(null);
    
    // Get organization ID
    const fetchOrganizationId = async () => {
      try {
        const { data: profile, error } = await profileService.getCurrentProfile();
        if (error) throw error;
        organizationId.value = profile?.org_id || null;
      } catch (error) {
        console.error('Error fetching profile:', error);
      }
    };

    const fetchContacts = async () => {
      loading.value = true;
      try {
        if (!organizationId.value) {
          console.error('No organization ID found');
          loading.value = false;
          return;
        }
        
        // First get the total count for pagination
        const { count, error: countError } = await supabase
          .from('contacts')
          .select('*', { count: 'exact' })
          .eq('organization_id', organizationId.value);
        
        if (countError) throw countError;
        totalContacts.value = count || 0;
        
        // Then get the actual contacts for the current page
        const from = (currentPage.value - 1) * itemsPerPage.value;
        const to = from + itemsPerPage.value - 1;
        
        const { data, error } = await supabase
          .from('contacts')
          .select('*')
          .eq('organization_id', organizationId.value)
          .range(from, to);
        
        if (error) throw error;
        contacts.value = data || [];
      } catch (error) {
        console.error('Error fetching contacts:', error);
      } finally {
        loading.value = false;
      }
    };
    
    // Filter contacts based on search query and status filter
    const filteredContacts = computed(() => {
      return contacts.value.filter(contact => {
        const matchesSearch = contact.name.toLowerCase().includes(searchQuery.value.toLowerCase()) || 
                             (contact.phone && contact.phone.includes(searchQuery.value));
        const matchesStatus = statusFilter.value === 'All' || contact.status === statusFilter.value.toLowerCase();
        return matchesSearch && matchesStatus;
      });
    });
    
    const toggleDropdown = () => {
      showDropdown.value = !showDropdown.value;
    };
    
    const setStatusFilter = (status: string) => {
      statusFilter.value = status;
      showDropdown.value = false;
    };
    
    const toggleSelectAll = () => {
      if (selectAll.value) {
        selectedContacts.value = filteredContacts.value.map(contact => contact.id);
      } else {
        selectedContacts.value = [];
      }
    };
    
    const formatDate = (dateString: string | null) => {
      if (!dateString) return directT('contacts.notAvailable');
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
    };
    
    const capitalize = (str: string) => {
      return str.charAt(0).toUpperCase() + str.slice(1);
    };
    
    const getRandomUserImage = () => {
      const userNum = Math.floor(Math.random() * 12) + 1;
      return require(`@/assets/images/users/user${userNum}.jpg`);
    };
    
    const getStatusDisplay = (status: string) => {
      if (status === 'active') return directT('contacts.active');
      if (status === 'deactive') return directT('contacts.inactive');
      return capitalize(status);
    };
    
    const getDisplayStatusFilter = () => {
      if (statusFilter.value === 'All') return directT('contacts.all');
      if (statusFilter.value === 'active') return directT('contacts.active');
      if (statusFilter.value === 'deactive') return directT('contacts.inactive');
      return statusFilter.value;
    };
    
    // Define updateContactProfilePicture function before it's used
    const updateContactProfilePicture = async (id: string, profilePictureLink: string) => {
      try {
        const { error } = await supabase
          .from('contacts')
          .update({ profile_picture_link: profilePictureLink || null })
          .eq('id', id);
        
        if (error) throw error;
        
        // Refresh the list
        fetchContacts();
      } catch (error) {
        console.error('Error updating contact profile picture:', error);
      }
    };
    
    // Edit contact popup
    const showEditPopup = ref(false);
    const currentEditContact = ref<any>(null);
    const editForm = reactive({
      id: '',
      name: '',
      phone: '',
      status: 'active',
      profile_picture_link: ''
    });

    const openEditPopup = (contact: any) => {
      currentEditContact.value = contact;
      editForm.id = contact.id;
      editForm.name = contact.name;
      editForm.phone = contact.phone || '';
      editForm.status = contact.status;
      editForm.profile_picture_link = contact.profile_picture_link || '';
      showEditPopup.value = true;
    };

    const closeEditPopup = () => {
      showEditPopup.value = false;
      currentEditContact.value = null;
    };

    const saveContactChanges = async () => {
      try {
        const { error } = await supabase
          .from('contacts')
          .update({
            name: editForm.name,
            phone: editForm.phone || null,
            status: editForm.status,
            profile_picture_link: editForm.profile_picture_link || null
          })
          .eq('id', editForm.id);
        
        if (error) throw error;
        
        // Refresh the list
        fetchContacts();
        closeEditPopup();
      } catch (error) {
        console.error('Error updating contact:', error);
      }
    };
    
    const editContact = (contact: any) => {
      openEditPopup(contact);
    };
    
    const deleteContact = async (id: string) => {
      if (confirm(directT('contacts.confirmDelete'))) {
        try {
          const { error } = await supabase
            .from('contacts')
            .delete()
            .eq('id', id);
          
          if (error) throw error;
          
          // Remove from selected contacts if it was selected
          selectedContacts.value = selectedContacts.value.filter(contactId => contactId !== id);
          
          // Refresh the list
          fetchContacts();
        } catch (error) {
          console.error('Error deleting contact:', error);
        }
      }
    };
    
    const handlePageChange = (page: number) => {
      currentPage.value = page;
      fetchContacts();
    };
    
    // Watch for changes in search query to filter results
    watch(searchQuery, () => {
      // Reset pagination when searching
      currentPage.value = 1;
    });
    
    // Watch for changes in status filter
    watch(statusFilter, () => {
      // Reset pagination when filtering
      currentPage.value = 1;
    });
    
    // View contact popup
    const showViewPopup = ref(false);
    const currentViewContact = ref<any>(null);

    const openViewPopup = (contact: any) => {
      currentViewContact.value = contact;
      showViewPopup.value = true;
    };

    const closeViewPopup = () => {
      showViewPopup.value = false;
      currentViewContact.value = null;
    };
    
    const viewContact = (contact: any) => {
      openViewPopup(contact);
    };
    
    onMounted(async () => {
      await fetchOrganizationId();
      fetchContacts();
    });

    return {
      directT,
      contacts,
      loading,
      searchQuery,
      statusFilter,
      showDropdown,
      selectedContacts,
      selectAll,
      currentPage,
      filteredContacts,
      totalContacts,
      itemsPerPage,
      toggleDropdown,
      setStatusFilter,
      toggleSelectAll,
      formatDate,
      capitalize,
      getRandomUserImage,
      getStatusDisplay,
      getDisplayStatusFilter,
      viewContact,
      editContact,
      deleteContact,
      handlePageChange,
      showEditPopup,
      editForm,
      openEditPopup,
      closeEditPopup,
      saveContactChanges,
      updateContactProfilePicture,
      showViewPopup,
      currentViewContact,
      openViewPopup,
      closeViewPopup
    };
  }
});
</script>
